import { Args, Ctx, Query, Resolver } from 'type-graphql'

import { config } from '@things-factory/env'
import { Favorite } from '@things-factory/fav-base'
import { buildQuery, getRepository, ListParam } from '@things-factory/shell'

import { Board } from '../board/board.js'
import { BoardFavorite, BoardFavoriteList } from './board-favorite-type.js'

const ORMCONFIG = config.get('ormconfig', {})
const DATABASE_TYPE = ORMCONFIG.type

@Resolver(BoardFavorite)
export class BoardFavoriteQuery {
  @Query(returns => BoardFavoriteList, { description: 'To fetch multiple BoardFavorites' })
  async favoriteBoards(
    @Args(type => ListParam) params: ListParam,
    @Ctx() context: ResolverContext
  ): Promise<BoardFavoriteList> {
    const { user } = context.state

    const queryBuilder = getRepository(Board).createQueryBuilder()
    buildQuery(queryBuilder, params, context)

    var joinStatement = ''
    switch (DATABASE_TYPE) {
      case 'postgres':
        joinStatement = 'CAST(Board.id as VARCHAR) = Favorite.routing'
        break
      case 'sqlite':
      default:
        joinStatement = 'Board.id = Favorite.routing'
    }

    var qb = queryBuilder
      .innerJoin(Favorite, 'Favorite', joinStatement)
      .select([
        'Board.id as id',
        'Board.name as name',
        'Board.description as description',
        'Board.thumbnail as thumbnail',
        'Favorite.id as favoriteId'
      ])
      .andWhere('Favorite.user = :userId', {
        userId: user.id
      })

    const items = await qb.getRawMany()
    const total = await qb.getCount()

    return { items, total }
  }
}
